import React from 'react'
import Helmet from 'react-helmet'
import bannerImage from '../../components/newLayout/assets/distributor/banner.jpg'
import man from '../../components/newLayout/assets/distributor/man.png'
import workingImage from '../../components/newLayout/assets/distributor/work.png'
import Card from '../../components/newLayout/components/Card'
import FuctionContent from '../../components/newLayout/components/FunctionContent'
import LandingForm from '../../components/newLayout/components/LandingForm'
import TimelineItem from '../../components/newLayout/components/TimelineItem'
import Footer from '../../components/newLayout/Footer'
import Header from '../../components/newLayout/PageHeader'

// eslint-disable-next-line no-unused-expressions
typeof window !== 'undefined' && require('boxicons')

function IndexPage() {
  return (
    <div>
      <Header landingName="distributor" />
      <Helmet
        title="Distributor — Softin Sistemas"
        link={[
          {
            rel: 'icon',
            type: 'image/png',
            sizes: '32x32',
            href: require('../../assets/img/logos/gravittem/distributor.svg')
          }
        ]}
      />
      <div
        className="content-container d-lg-flex mb-0 align-items-center"
        style={{
          background: `url(${bannerImage}) no-repeat fixed left`
        }}
      >
        <img
          alt=""
          className="d-none d-lg-block"
          src={bannerImage}
          style={{
            width: '-webkit-fill-available'
          }}
        />
        <div className="p-2 p-md-5 img-position-absolute position-relative d-lg-flex mx-0 align-items-center">
          <h1 className="font-bold text-white text-center text-md-left pb-4 pb-md-0 font-inter pr-lg-3">
            Ferramenta para o gerenciamento de distribuidora de peças
          </h1>
          <Card className="background-black">
            <h3 className="text-white font-inter">
              Preencha os campos abaixo para que nossa equipe entre em contato
            </h3>
            <LandingForm
              buttonDescription="Entre em contato"
              textDecoration="text-green"
              buttonColor="btn-green"
              landingName="Landing page distributor"
            />
          </Card>
        </div>
      </div>

      <div className="background-white py-3 pb-6">
        <h1 className="font-bold text-center text-black m-5 font-inter">
          Administre todo o fluxo de sua operação
        </h1>
        <div className="row mx-4 justify-content-md-center">
          <FuctionContent
            className="col-12 col-md-4 col-xl-3"
            title="Orçamento de peças"
            text="Gerencia as etapas de venda desde o orçamento de peças, formas de pagamentos, eventuais descontos e muito mais"
            image="chat"
            iconColor="#43a791"
          />
          <FuctionContent
            className="col-12 col-md-4 col-xl-3"
            title="Controle de estoque"
            text="Mantenha uma gestão eficiente e precisa de seu estoque de peças acompanhando desde o controle, recepção, armazenamento e alocação de inventário"
            image="box"
            iconColor="#43a791"
          />
          <FuctionContent
            className="col-12 col-md-4 col-xl-3"
            title="Gestão financeira"
            text="Mantenha a saúde financeira do seu negócio tando total controle do contas a pagar e receber, movimentação de conta corrente e fluxo de caixa"
            image="coin"
            iconColor="#43a791"
          />
        </div>
      </div>

      <h1
        className="font-bold text-center text-black p-5 mb-0 my-16 font-inter"
        style={{
          backgroundColor: '#fafafa'
        }}
      >
        Entenda como funciona na prática
      </h1>
      <div
        className="content-container d-lg-flex align-items-center mx-2"
        style={{
          backgroundColor: '#fafafa'
        }}
      >
        <img alt="" className="w-100 img-sizing" src={workingImage} />
        <div className="p-5 ml-auto mx-0">
          <TimelineItem
            icon="user-detail"
            iconType="solid"
            iconColor="#43a791"
            title="Identificação do cliente"
            description="Realizar cadastro do cliente, com as informações necessárias para efetuar a venda"
          />
          <TimelineItem
            icon="file"
            iconColor="#43a791"
            title="Venda das peças"
            description="Efetuar uma venda de balcão ou, caso seja necessário, efetuar um orçamento das peças aguardando posteriormente a aprovação do mesmo para dar continuidade na efetivação da venda"
          />
          <TimelineItem
            icon="paper-plane"
            iconColor="#43a791"
            title="Emissão"
            description="Emita documento fiscal através do módulo Gravíttem Tax"
          />
          <TimelineItem
            icon="box"
            iconColor="#43a791"
            title="Controle de estoque"
            description="Ao efetuar a emissão do documento fiscal, será efetuada a baixa da peça no estoque"
          />
          <TimelineItem
            icon="coin"
            iconColor="#43a791"
            title="Financeiro"
            description="Gere o contas a receber da venda efetuada e tenha controle do contas a pagar através do recebimento das notas fiscais relacionadas as peças adquiridas para o seu estoque"
            last
          />
        </div>
      </div>

      <div className="background-green d-md-flex pb-6 px-3 px-md-5 px-md-8">
        <div className="pb-3 pb-md-0">
          <h2 className="font-bold text-white pt-5 text-center text-md-left font-inter">
            Conheça o Gravíttem e junte-se aos mais de 400 clientes espalhados
            no Brasil inteiro
          </h2>
          <LandingForm
            buttonDescription="Fazer parte do Gravíttem"
            buttonColor="btn-dark-green"
            textDecoration="text-white underline"
            landingName="Landing page distributor"
          />
        </div>
        <img
          alt=""
          className="d-none d-lg-block w-50 align-self-end ml-md-5 img-sizing"
          src={man}
        />
      </div>
      <Footer />
    </div>
  )
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/gravittem/distributor_2021.js